// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.03)}", ""]);
// Exports
module.exports = exports;
